module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header fuente"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "fuente hidden-xs",
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayName) + " "), _c('b', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu-custom"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "limited-text"
  }, [_vm._v(_vm._s(_vm.nombres))])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "limited-text",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("DNI: " + _vm._s(_vm.dni))])])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu",
    on: {
      "click": function($event) {
        return _vm.cerrarSesion()
      }
    }
  }, [_vm._m(2)])])])])]), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "fuente logo",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/hombre.png",
      "width": "40",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fuente fs-15",
    staticStyle: {
      "color": "#333",
      "letter-spacing": "1px"
    }
  }, [_c('img', {
    staticClass: "fuente m-r-10",
    attrs: {
      "src": "/static/img/favicon.png",
      "width": "40",
      "alt": "logo"
    }
  }), _vm._v("USUARIOS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" "), _c('span', {
    staticClass: "fuente hidden-xs"
  }, [_vm._v("SALIR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('a', {
    staticClass: "fuente fs-13",
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Desarrollado por la Oficina de Tecnologías de la Información - 2018")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-897e6516"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 341
// module chunks = 1